import BaseStatisticsChart from './Chart';

export default BaseStatisticsChart;
